export default __webpack_public_path__ + "static/media/Saliti_discesi.fefbd9f6.png";